<div class="form">
	<form [formGroup]="connectionForm" role="form" (ngSubmit)="onSubmit(connectionForm.value)" autocomplete="off">
		<ion-item class="label">
			<ion-label>{{ 'connectionsModal.form.pathManually.alias' | translate }}</ion-label>
		</ion-item>
		<ion-item>
			<ion-input formControlName="aliasControl" type="text" placeholder="Canada Geologists"></ion-input>
		</ion-item>
		<ion-item class="label">
			<ion-label>{{ 'connectionsModal.form.pathManually.apiKey' | translate }}</ion-label>
		</ion-item>
		<ion-item>
			<ion-input
				formControlName="apiKeyControl"
				type="text"
				appDebounceKeyUpDirective
				debounce="500"
				(ionChange)="fieldValueChanged($event)"
			></ion-input>
		</ion-item>
		<ion-item class="label">
			<ion-label>{{ 'connectionsModal.form.pathManually.path' | translate }}</ion-label>
		</ion-item>
		<ion-item>
			<ion-input
				formControlName="pathControl"
				type="text"
				placeholder="https://"
				appDebounceKeyUpDirective
				debounce="500"
				(ionChange)="fieldValueChanged($event)"
			></ion-input>
		</ion-item>
		<ion-item class="validation-errors">
			<div>
				<ng-container *ngFor="let validation of formValidationMessages">
					<div
						class="error-message"
						*ngIf="
							connectionForm.get('pathControl').hasError(validation.type) &&
							connectionForm.get('pathControl').dirty
						"
					>
						{{ validation.message }}
					</div>
				</ng-container>
			</div>
		</ion-item>

		<ion-item>
			<button type="submit" [ngClass]="{ disabled: !connectionForm.valid }">
				{{ 'connectionsModal.form.pathManually.submit' | translate }}
			</button>
		</ion-item>
	</form>
</div>
